(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-measurements"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-measurements')) {
    customElements.define('product-measurements', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return
        this.dataset.initialized = 'true'

        const trigger = this.querySelector('[data-measurements-open]')
        const dialog = this.querySelector('[data-measurements-dialog]')
        const closeButton = this.querySelector('[data-measurements-close]')
        const dataElement = this.querySelector('[data-measurement-data]')
        const tabs = Array.from(this.querySelectorAll('[role="tab"]'))
        const tabPanel = this.querySelector('[role="tabpanel"]')
        const sizeSelector = this.closest('.product-form__field')?.querySelector('[data-option-selector]')
        let measurementData

        try {
          measurementData = JSON.parse(dataElement.textContent)
        } catch {
          measurementData = {}
        }
        if (!measurementData || typeof measurementData !== 'object') measurementData = {}

        const sizeAliases = {
          XXL: '2XL',
          '2XL': 'XXL',
          xxl: '2xl',
          '2xl': 'xxl',
        }
        const getMeasurements = (size) => measurementData[size] || measurementData[sizeAliases[size]] || {}

        const selectSize = (size, focusTab = false) => {
          const tab = tabs.find((item) => item.dataset.measurementSize === size)
          if (!tab) return

          const values = getMeasurements(size)
          tabs.forEach((item) => {
            const isSelected = item === tab
            item.setAttribute('aria-selected', String(isSelected))
            item.tabIndex = isSelected ? 0 : -1
          })

          if (tabPanel) tabPanel.setAttribute('aria-labelledby', tab.id)
          this.querySelectorAll('[data-measurement-row]').forEach((row) => {
            const value = values[row.dataset.measurementRow]
            const hasValue = value !== null && value !== undefined && String(value).trim() !== ''
            const valueElement = row.querySelector('[data-measurement-value]')
            const unitElement = row.querySelector('[data-measurement-unit]')
            valueElement.textContent = hasValue ? value : '—'
            unitElement.hidden = !hasValue
            if (hasValue) valueElement.removeAttribute('aria-label')
            else valueElement.setAttribute('aria-label', this.dataset.unavailableLabel)
          })

          if (focusTab) tab.focus()
        }

        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => selectSize(tab.dataset.measurementSize))
          tab.addEventListener('keydown', (event) => {
            let nextIndex
            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (index + 1) % tabs.length
            if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (index - 1 + tabs.length) % tabs.length
            if (event.key === 'Home') nextIndex = 0
            if (event.key === 'End') nextIndex = tabs.length - 1
            if (nextIndex === undefined) return
            event.preventDefault()
            selectSize(tabs[nextIndex].dataset.measurementSize, true)
          })
        })

        trigger.addEventListener('click', () => {
          if (sizeSelector) selectSize(sizeSelector.value)
          dialog.showModal()
          document.documentElement.classList.add('product-measurements-open')
          closeButton.focus()
        })

        closeButton.addEventListener('click', () => dialog.close())
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close()
        })
        dialog.addEventListener('close', () => {
          if (!document.querySelector('[data-measurements-dialog][open]')) {
            document.documentElement.classList.remove('product-measurements-open')
          }
          trigger.focus()
        })

        if (sizeSelector) {
          sizeSelector.addEventListener('change', () => selectSize(sizeSelector.value))
          selectSize(sizeSelector.value)
        }
      }
    })
  }
  } catch(e) { console.error(e); }
})();

})();
